import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceProject } from 'src/app/core/interfaces/service/service-project';
import { ApiService } from 'src/app/core/services/api/api.service';

@Component({
  selector: 'app-service-counts-list',
  templateUrl: './service-counts-list.component.html',
  styleUrls: ['./service-counts-list.component.scss'],
})
export class ServiceCountsListComponent implements OnInit {
  @Input() status: string;
  statusMessage: string;
  statusNumber: number;

  displayedColumns: string[] = [
    'customer',
    'serviceProjectId',
    'createdDate',
    'createdBy',
    'projectTypeName',
    'jobaddress',
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  serviceProjectArray: ServiceProject[] = [];
  dataSource: MatTableDataSource<ServiceProject>;

  isLoading: boolean = true;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.dataSource = new MatTableDataSource();

    this.route.paramMap.subscribe((params) => {
      this.status = params.get('status') as string;
      this.getServiceProjectsByStatus(this.status);
    });
  }

  getServiceProjectsByStatus(status: string) {
    this.isLoading = true;
    this.dataSource = new MatTableDataSource();

    if (status) {
      switch (status) {
        case 'pendingServiceToSchedule':
          this.statusNumber = 0;
          this.statusMessage = 'Pending Service To Schedule';
          break;
        case 'serviceScheduled':
          this.statusNumber = 1;
          this.statusMessage = 'Service Scheduled';
          break;
        case 'assuranceProjectsToSchedule':
          this.statusNumber = 2;
          this.statusMessage = 'Assurance To Schedule';
          break;
      }
    }

    if (this.statusNumber != undefined) {
      this.apiService.getServiceProjectsByStatus(this.statusNumber).subscribe({
        next: (response) => {
          this.isLoading = false;
          this.serviceProjectArray = response;
          this.dataSource = new MatTableDataSource(this.serviceProjectArray);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        },
        error: (e) => {
          this.isLoading = false;
          console.error(e);
        },
      });
    }
  }

  goToServiceProject(row: ServiceProject) {
    this.router.navigate(['customers/' + row.customerId], {
      queryParams: {
        jobAddressId: row.jobAddressId,
        serviceProjectId: row.serviceProjectId,
      },
    });
  }

  filterServiceProjects(event: Event) {
    const filterString = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterString.trim().toLowerCase();
  }
}
